import Purchases from "./Purchases";

class ActivePurchases extends Purchases{
    loadPurchases = () => {
        this.props.loadGet("/purchases?status=active", this.loadContent, this.loadError)
    }
}
export default ActivePurchases;